// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1d6MA","questions":"styles_questions__11Ap6","footer":"styles_footer__3j2Ee"};